import { render, staticRenderFns } from "./BlockVideo.vue?vue&type=template&id=4fc50b31&scoped=true"
import script from "./BlockVideo.vue?vue&type=script&lang=js"
export * from "./BlockVideo.vue?vue&type=script&lang=js"
import style0 from "./BlockVideo.vue?vue&type=style&index=0&id=4fc50b31&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc50b31",
  null
  
)

export default component.exports